import { doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

const TEMPLATES = {
  'welcome': {
    label: 'Welcome Email',
    subject: {
      en: 'Welcome! - Hoang Uyen Da Lat Homestay',
      vi: 'Chào mừng bạn! - Hoàng Uyên Đà Lạt Homestay'
    },
    heading: { en: 'Welcome!', vi: 'Chào mừng bạn!' },
    bodyText: {
      en: 'Thank you for subscribing to Hoang Uyen Da Lat Homestay! You will receive updates about new activities and special offers.',
      vi: 'Cảm ơn bạn đã đăng ký nhận thông báo từ Hoàng Uyên Đà Lạt Homestay! Bạn sẽ nhận được thông tin về các hoạt động mới và ưu đãi đặc biệt.'
    },
    footerText: {
      en: 'You received this email because you subscribed to notifications from Hoang Uyen Da Lat Homestay.',
      vi: 'Bạn nhận được email này vì đã đăng ký nhận thông báo từ Hoàng Uyên Đà Lạt Homestay.'
    }
  },
  'booking-guest': {
    label: 'Booking Confirmation (Guest)',
    subject: {
      en: 'Booking Request Received - Hoang Uyen Da Lat Homestay',
      vi: 'Xác nhận yêu cầu đặt phòng - Hoàng Uyên Đà Lạt Homestay'
    },
    heading: { en: 'Booking Request Received', vi: 'Xác nhận yêu cầu đặt phòng' },
    bodyText: {
      en: 'Dear {guestName},<br><br>Thank you for your booking request. We have received your request and will confirm within 24 hours.',
      vi: 'Xin chào {guestName},<br><br>Cảm ơn bạn đã gửi yêu cầu đặt phòng. Chúng tôi đã nhận được yêu cầu của bạn và sẽ xác nhận trong vòng 24 giờ.'
    },
    footerText: {
      en: 'If you have any questions, please contact us by email or phone.',
      vi: 'Nếu bạn có câu hỏi, vui lòng liên hệ với chúng tôi qua email hoặc điện thoại.'
    }
  },
  'booking-admin': {
    label: 'Booking Notification (Admin)',
    subject: {
      en: 'New Booking: {guestName} ({checkIn} - {checkOut})',
      vi: 'Đặt phòng mới: {guestName} ({checkIn} - {checkOut})'
    },
    heading: { en: 'New Booking Request', vi: 'Yêu cầu đặt phòng mới' },
    bodyText: {
      en: 'New booking from <strong>{guestName}</strong><br>Email: {email}<br>Phone: {phone}<br>Source: {source}<br>Language: {language}',
      vi: 'Đặt phòng mới từ <strong>{guestName}</strong><br>Email: {email}<br>Điện thoại: {phone}<br>Nguồn: {source}<br>Ngôn ngữ: {language}'
    },
    footerText: {
      en: '<a href="https://hoanguyendalat.com/admin" style="color: #c4704b; font-weight: bold;">Go to Admin Panel to manage this booking</a>',
      vi: '<a href="https://hoanguyendalat.com/admin" style="color: #c4704b; font-weight: bold;">Vào trang quản trị để quản lý đặt phòng</a>'
    }
  },
  'booking-confirmed': {
    label: 'Booking Confirmed',
    subject: {
      en: 'Booking Confirmed! - Hoang Uyen Da Lat Homestay',
      vi: 'Đặt phòng đã được xác nhận! - Hoàng Uyên Đà Lạt Homestay'
    },
    heading: { en: 'Booking Confirmed!', vi: 'Đặt phòng đã được xác nhận!' },
    bodyText: {
      en: 'Dear {guestName},<br><br>We are happy to confirm your booking. We look forward to welcoming you!',
      vi: 'Xin chào {guestName},<br><br>Chúng tôi vui mừng thông báo đặt phòng của bạn đã được xác nhận. Chúng tôi rất mong chờ đón bạn!'
    },
    footerText: {
      en: 'If you have any questions, please contact us by email or phone.',
      vi: 'Nếu bạn có câu hỏi, vui lòng liên hệ với chúng tôi qua email hoặc điện thoại.'
    }
  },
  'booking-cancelled': {
    label: 'Booking Cancelled',
    subject: {
      en: 'Booking Cancelled - Hoang Uyen Da Lat Homestay',
      vi: 'Đặt phòng đã bị hủy - Hoàng Uyên Đà Lạt Homestay'
    },
    heading: { en: 'Booking Cancelled', vi: 'Đặt phòng đã bị hủy' },
    bodyText: {
      en: 'Dear {guestName},<br><br>We regret to inform you that your booking has been cancelled. If you have any questions, please contact us.',
      vi: 'Xin chào {guestName},<br><br>Chúng tôi rất tiếc thông báo đặt phòng của bạn đã bị hủy. Nếu bạn có câu hỏi, vui lòng liên hệ với chúng tôi.'
    },
    footerText: {
      en: 'If you have any questions, please contact us by email or phone.',
      vi: 'Nếu bạn có câu hỏi, vui lòng liên hệ với chúng tôi qua email hoặc điện thoại.'
    }
  },
  'event-registration-verification': {
    label: 'Event Registration - Email Verification',
    subject: {
      en: 'Verify Your Registration - Hoang Uyen Da Lat',
      vi: 'Xac minh dang ky cua ban - Hoang Uyen Da Lat'
    },
    heading: { en: 'Verify Your Email', vi: 'Xac minh email cua ban' },
    bodyText: {
      en: 'Dear {name},<br><br>Thank you for registering for <strong>{eventName}</strong>. Please click the button below to verify your email address.',
      vi: 'Xin chao {name},<br><br>Cam on ban da dang ky tham gia <strong>{eventName}</strong>. Vui long nhan nut ben duoi de xac minh dia chi email cua ban.'
    },
    footerText: {
      en: 'If you did not register for this event, please ignore this email.',
      vi: 'Neu ban khong dang ky su kien nay, vui long bo qua email nay.'
    }
  },
  'event-registration-confirmed': {
    label: 'Event Registration - Confirmed',
    subject: {
      en: 'Registration Confirmed! - {eventName}',
      vi: 'Dang ky da duoc xac nhan! - {eventName}'
    },
    heading: { en: 'Registration Confirmed!', vi: 'Dang ky da duoc xac nhan!' },
    bodyText: {
      en: 'Dear {name},<br><br>Your registration for <strong>{eventName}</strong> has been confirmed! Your registration code is <strong>{registrationCode}</strong>.',
      vi: 'Xin chao {name},<br><br>Dang ky cua ban cho <strong>{eventName}</strong> da duoc xac nhan! Ma dang ky cua ban la <strong>{registrationCode}</strong>.'
    },
    footerText: {
      en: 'If you have any questions, please contact us by email or phone.',
      vi: 'Neu ban co cau hoi, vui long lien he voi chung toi qua email hoac dien thoai.'
    }
  },
  'event-registration-rejected': {
    label: 'Event Registration - Rejected',
    subject: {
      en: 'Registration Update - {eventName}',
      vi: 'Cap nhat dang ky - {eventName}'
    },
    heading: { en: 'Registration Update', vi: 'Cap nhat dang ky' },
    bodyText: {
      en: 'Dear {name},<br><br>We regret to inform you that your registration for <strong>{eventName}</strong> could not be confirmed.{rejectionReason}',
      vi: 'Xin chao {name},<br><br>Chung toi rat tiec thong bao dang ky cua ban cho <strong>{eventName}</strong> khong duoc xac nhan.{rejectionReason}'
    },
    footerText: {
      en: 'If you have any questions, please contact us by email or phone.',
      vi: 'Neu ban co cau hoi, vui long lien he voi chung toi qua email hoac dien thoai.'
    }
  },
  'activity-notification': {
    label: 'New Activity Notification',
    subject: {
      en: 'New Activity: {activityName}',
      vi: 'Hoạt động mới: {activityName}'
    },
    heading: { en: 'New Activity for You!', vi: 'Hoạt động mới dành cho bạn!' },
    bodyText: {
      en: 'Check out our latest activity at Hoang Uyen Da Lat Homestay.',
      vi: 'Khám phá hoạt động mới nhất tại Hoàng Uyên Đà Lạt Homestay.'
    },
    footerText: {
      en: 'You received this email because you subscribed to notifications from Hoang Uyen Da Lat Homestay.',
      vi: 'Bạn nhận được email này vì đã đăng ký nhận thông báo từ Hoàng Uyên Đà Lạt Homestay.'
    }
  }
};

// Expose globally so it can be called from browser console:
// window.updateEmailTemplates()
window.updateEmailTemplates = updateEmailTemplates;

export async function updateEmailTemplates() {
  const results = [];
  for (const [id, data] of Object.entries(TEMPLATES)) {
    try {
      await setDoc(doc(db, 'emailTemplates', id), data, { merge: true });
      results.push({ id, success: true });
      console.log(`Updated: ${id}`);
    } catch (err) {
      results.push({ id, success: false, error: err.message });
      console.error(`Failed: ${id}`, err);
    }
  }
  return results;
}
